import { createFileRoute } from '@tanstack/react-router'
import { encountersQueryOptions } from '~/features/dashboard/pages/encounters/api/queries';
import { TodosPage } from '~/features/dashboard/pages/quick-actions/pages/todos'

export const Route = createFileRoute('/(dashboard)/dashboard/$program/todos/$tab')({
  beforeLoad: async ({ params }) => {
    const type = params.tab;
    if (type !== "consultation" && type !== "appointment" && type !== "refill") {
      return "consultation";
    }
  },
  loader: ({ context, params }) => {
    context.queryClient.ensureQueryData(encountersQueryOptions({ limit: 10, skip: 0, type: params.tab, date_filter: "today", type_sort_order: params.tab as "consultation" | "appointment" | "refill", status: "unresolved" }))
  },
  component: () => (
    <TodosPage />
  ),
})

